import OrganisationYearlyReportView from '@/template/views/OrganisationYearlyReportView.vue';
import OrganisationView from '@/template/components/organisationYearlyReport/OrganisationView.vue';
import ProfitsAndExpensesView from '@/template/components/organisationYearlyReport/ProfitsAndExpensesView.vue';
import BalanceSheetView from '@/template/components/organisationYearlyReport/BalanceSheetView.vue';
import AdministrationView from '@/template/components/organisationYearlyReport/AdministrationView.vue';
import InternalMonitoringView from '@/template/components/organisationYearlyReport/InternalMonitoringView.vue';
import AttachmentsView from '@/template/components/organisationYearlyReport/AttachmentsView.vue';
import ContactInfoView from '@/template/components/shared/ContactInfoView.vue';
export var route = {
    path: '/organisationYearlyReport/:id',
    component: OrganisationYearlyReportView,
    children: [{
            name: 'organisationYearlyReport',
            path: '',
            component: OrganisationView,
            meta: {
                title: 'Menu.Organisation',
                section: 1
            }
        },
        {
            name: 'profits-and-expenses',
            path: 'profitsAndExpenses',
            component: ProfitsAndExpensesView,
            meta: {
                title: 'Menu.ProfitsAndExpenses',
                section: 2,
                procurationRequired: true
            }
        },
        {
            name: 'balance-sheet',
            path: 'balanceSheet',
            component: BalanceSheetView,
            meta: {
                title: 'Menu.BalanceSheet',
                section: 3,
                procurationRequired: true
            }
        },
        {
            name: 'administration',
            path: 'administration',
            component: AdministrationView,
            meta: {
                title: 'Menu.Administration',
                section: 4
            }
        },
        {
            name: 'internal-monitoring',
            path: 'internalMonitoring',
            component: InternalMonitoringView,
            meta: {
                title: 'Menu.InternalMonitoring',
                section: 5
            }
        },
        {
            name: 'attachments',
            path: 'attachments',
            component: AttachmentsView,
            meta: {
                title: 'Menu.Attachments',
                section: 6
            }
        },
        {
            name: 'yearly-report-contact-information',
            path: 'yearlyReportContactInformation',
            component: ContactInfoView,
            meta: {
                title: 'Menu.ContactInfo',
                section: 7
            }
        }
    ]
};
